import React, { useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import ProgramModules from "./components/ProgramModules";
import { useProgram } from "../../../context/ProgramContext";
import { ProgramWeek } from "../../../types/ProgramModel";

const useStyles = {
  stickyBox: {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1000, // Ensure it stays on top of other content
    boxShadow: "0 1px 20px rgba(0, 0, 0, 0.2)", // Very light shadow
    padding: "1rem", // Add padding if needed
  },
};

const Programs: React.FC = () => {
  const { programs, fetchPrograms, fetchProgramWeek } = useProgram();

  useEffect(() => {
    const loadData = async () => {
      await fetchPrograms();
    };

    loadData();
  }, [fetchPrograms]);

  const getProgramWeek = async (programId: string, week: ProgramWeek) => {
    if (week.modules?.length) {
      return;
    }
    fetchProgramWeek(programId, week);
  };

  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      {programs.map((program) => (
        <Grid item xs={12} key={program.id}>
          <Box sx={useStyles.stickyBox}>
            <Typography variant="h4">{program.name}</Typography>
            <Typography variant="subtitle1">
              {program.weekCount} weeks
            </Typography>
          </Box>
          {program.weeks?.map((week) => (
            <Accordion
              key={week.weekId}
              onChange={() => getProgramWeek(program.id, week)}
            >
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1">
                  Week {week.weekNumber}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ProgramModules
                  modules={week.modules}
                  programId={program.id}
                  weekNumber={week.weekNumber}
                />
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      ))}
    </Grid>
  );
};

export default Programs;
